export const categories = [
  { id: "all", name: "全部", slug: "all", description: "浏览全部韩漫作品" },
  { id: "romance", name: "恋爱", slug: "romance", description: "甜到心里的爱情故事" },
  { id: "fantasy", name: "奇幻", slug: "fantasy", description: "穿越异世界的冒险旅程" },
  { id: "action", name: "动作", slug: "action", description: "热血沸腾的战斗场面" },
  { id: "drama", name: "剧情", slug: "drama", description: "引人入胜的精彩故事" },
  { id: "thriller", name: "悬疑", slug: "thriller", description: "扣人心弦的推理悬疑" },
  { id: "comedy", name: "搞笑", slug: "comedy", description: "轻松愉快的爆笑日常" },
  { id: "daily", name: "日常", slug: "daily", description: "温馨治愈的日常生活" },
  { id: "bl", name: "BL", slug: "bl", description: "心动不已的BL故事" },
];

export const categoryMap: Record<string, string> = {
  all: "全部",
  romance: "恋爱",
  fantasy: "奇幻",
  action: "动作",
  drama: "剧情",
  thriller: "悬疑",
  comedy: "搞笑",
  daily: "日常",
  bl: "BL",
};